/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Layout.jsx
 * description   : {{insert here}}
 * creation date : 01/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    Outlet,
} from 'react-router-dom';

import {
    View,
    Flex,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
    toolKit,
} from '@/components/core';

import Header from '@/components/layouts/auth/Header';
import Footer from '@/components/layouts/auth/Footer';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function AuthenticatorContainer() {
    // Component context
    const { ctx } = useComponentContext();

    return (
        <Fragment>
            <View
                className='authenticator-layout'
            >
                <View
                    className='authenticator-container'
                >
                    <View
                        className='authenticator-router'
                    >
                        <Header />
                        <Outlet />
                        <Footer />
                    </View>

                    <View
                        height={ctx.theme.tokens.space.xs}
                    />
                </View>
            </View>
        </Fragment>
    );
}

function Layout() {
    // Component context
    const { ctx } = useComponentContext();

    return (
        <Fragment>
            <Flex
                direction='row'
                justifyContent='center'
                alignItems='center'
                alignContent='center'
                wrap='wrap'
                gap={ctx.theme.tokens.space.zero}
                width={ctx.theme.tokens.space.relative.full}
                height={ctx.theme.tokens.space.relative.full}
                position='fixed'
            >
                <View
                    width={
                        (ctx.runtime.screen.viewPort === toolKit.enums.window.viewPortTypes.LARGE) ?
                            '50%' :
                            ctx.theme.tokens.space.relative.full
                    }
                    height={ctx.theme.tokens.space.relative.full}
                >
                    <AuthenticatorContainer />
                </View>

                {(ctx.runtime.screen.viewPort === toolKit.enums.window.viewPortTypes.LARGE) &&
                    <View
                        width='50%'
                        className='layout-auth-background'
                    >
                        <View
                            className='layout-auth-background-pattern'
                        />
                    </View>
                }
            </Flex>
        </Fragment >
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Layout;



// End of file
